/**
 * List workspace channels. Reads from the shell's StructuredCacheAdapter
 * if available (Desktop), otherwise falls through to a live Hub fetch and
 * write-throughs the result into cache if the shell has one. Web has no
 * cache in phase 1, so it always hits Hub.
 */
export async function listChannels(ctx, workspaceId) {
    const cache = ctx.shell.structuredCache;
    if (cache) {
        const cached = await cache.listChannels(workspaceId);
        if (cached.length > 0)
            return cached;
    }
    const fresh = await ctx.hub.listChannels(workspaceId);
    if (cache)
        await cache.upsertChannels(fresh);
    return fresh;
}
//# sourceMappingURL=channels.js.map